import { SnowflakeSearchParams } from '../../interfaces/workflows/SnowflakeSearchResult';

export class SearchSnowflake {
    static readonly type = '[Snowflake] Search';
    constructor(
        public params: SnowflakeSearchParams,
        public page: number,
        public pageSize: number
    ) {}
}

export class ClearSnowflakeSearch {
    static readonly type = '[Snowflake] Clear Search';
}
